import React, { Component } from 'react';
import AdminMenu from '../../Modules/AdminMenu'
import MededelingBewerken from '../../Modules/Mededelingen/Edit'

class MededelingEdit extends Component {

  render() {
    return (
      <div className="route">
        <AdminMenu />
        <h1 className="pageTitle">
          Mededeling bewerken
          </h1>
        <div className="grey-bg">
          <MededelingBewerken id={this.props.match.params.id} />
        </div>
      </div>
    );
  }
}

export default MededelingEdit;



// WEBPACK FOOTER //
// ./src/components/Admin/Pages/Mededelingen/Edit.js